import clsx from "clsx"
import React from "react"
import { Alert } from "react-bootstrap"
import { FormattedMessage, injectIntl } from "react-intl"
import { WarningIcon } from "../../common/icon/icons/WarningIcon"
import { GlobalHelper } from "../../indexImports"


type OwnProps = {
    className?: string
    gap?: 1 | 2 | 3 | 4 | 5 | 6
    isAccountPaymentGatewayTestMode?: boolean
}

const TestModeAlert = ({ className, gap = 2, isAccountPaymentGatewayTestMode }: OwnProps) => {

    const isNotTestMode = isAccountPaymentGatewayTestMode !== undefined ? !isAccountPaymentGatewayTestMode : !GlobalHelper.isPaymentGatewayTestMode()
    
    if(isNotTestMode){
        return <></>
    }

    return (
        <Alert 
            variant={"warning"} 
            className={clsx("d-flex align-items-center", className, `gap-${gap}`)}
        >
            <WarningIcon />
            <FormattedMessage
                id="payment_processing.components.test_mode_alert"
                defaultMessage="You are in test mode" />
        </Alert>
    ) 
}

export default injectIntl(TestModeAlert)


// WEBPACK FOOTER //
// ./src/payment-processing/components/TestModeAlert.tsx